<template>
    <rkm-modal
        :loading="loading"
        extra-large
        ref="Modal"
        title="Cadastro individual - Inconsistências"
    >
        <template v-if="data">

            <Inconsistencia
                v-if="inconsistenciaVersao"
                :inconsistencias="inconsistenciaVersao"
            />

            <rkm-area
                title="Profissional responsável"
                type="fieldset"
            >
                <rkm-row>
                    <rkm-col cols="6">
                        <Item
                            label="Nome"
                            :value="data.profissional.campos.profissionalNome"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="CNS"
                            :value="data.profissional.campos.profissionalCNS"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="CNES"
                            :value="data.profissional.campos.cnes"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="IBGE"
                            :value="data.profissional.campos.codigoIbgeMunicipio"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="3">
                        <Item
                            label="INE"
                            :value="data.profissional.campos.ine"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <Item
                            label="CBO"
                            :value="data.profissional.campos.cboCodigo2002"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <Item
                            label="Data"
                            :value="data.profissional.campos.dataAtendimento"
                        />
                    </rkm-col>
                </rkm-row>

                <Inconsistencia :inconsistencias="data.profissional.inconsistencias" />
            </rkm-area>

            <rkm-area
                title="Identificação do paciente"
                type="fieldset"
            >
                <rkm-row>
                    <rkm-col cols="6">
                        <Item
                            label="Nome"
                            :value="data.paciente.campos.nomeCidadao"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <Item
                            label="Nome social"
                            :value="data.paciente.campos.nomeSocial"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="2">
                        <Item
                            label="CNS"
                            :value="data.paciente.campos.cnsCidadao"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="CPF"
                            :value="data.paciente.campos.cpfCidadao"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="PIS / PASEP | NIS"
                            :value="data.paciente.campos.numeroNisPisPasep"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="Data de nascimento"
                            :value="data.paciente.campos.dataNascimentoCidadao"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="Sexo"
                            :value="data.paciente.campos.sexoCidadao"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="Raça/cor"
                            :value="data.paciente.campos.racaCorCidadao"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="2">
                        <Item
                            label="Etnia"
                            :value="data.paciente.campos.etnia"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="É responsável"
                            :value="data.paciente.campos.statusEhResponsavel"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="Telefone"
                            :value="data.paciente.campos.telefoneCelular"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <Item
                            label="E-mail"
                            :value="data.paciente.campos.emailCidadao"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="IBGE (Nascimento)"
                            :value="data.paciente.campos.codigoIbgeMunicipioNascimento"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="2">
                        <Item
                            label="Nacionalidade"
                            :value="data.paciente.campos.nacionalidadeCidadao"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="País de nascimento"
                            :value="data.paciente.campos.paisNascimento"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="Data de naturalização"
                            :value="data.paciente.campos.dtNaturalizacao"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <Item
                            label="Portaria de naturalização"
                            :value="data.paciente.campos.portariaNaturalizacao"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <Item
                            label="Data de entrada no Brasil"
                            :value="data.paciente.campos.dtEntradaBrasil"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="4">
                        <Item
                            label="Nome da mãe"
                            :value="data.paciente.campos.nomeMaeCidadao"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="Desconhece mãe"
                            :value="data.paciente.campos.desconheceNomeMae"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <Item
                            label="Nome do pai"
                            :value="data.paciente.campos.nomePaiCidadao"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="Desconhece pai"
                            :value="data.paciente.campos.desconheceNomePai"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <Item
                            label="Microárea"
                            :value="data.paciente.campos.microArea"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <Item
                            label="Fora de área"
                            :value="data.paciente.campos.stForaArea"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="4">
                        <Item
                            label="Estado civil"
                            :value="data.paciente.campos.estadoCivil"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <Item
                            label="Tipo sanguíneo"
                            :value="data.paciente.campos.tipoSanguineo"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <Item
                            label="DNV"
                            :value="data.paciente.campos.dnv"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="4">
                        <Item
                            label="Não possui CPF"
                            :value="data.paciente.campos.stNaoPossuiCpf"
                        />
                    </rkm-col>

                    <rkm-col cols="8">
                        <Item
                            label="Justificativa de não possuir CPF"
                            :value="data.paciente.campos.justificativaNaoPossuiCpf"
                        />
                    </rkm-col>
                </rkm-row>

                <Inconsistencia :inconsistencias="data.paciente.inconsistencias" />
            </rkm-area>

            <rkm-area
                title="Informação Sociodemográfica"
                type="fieldset"
            >
                <rkm-row>
                    <rkm-col cols="6">
                        <Item
                            label="Relação de parentesco com o responsável familiar"
                            :value="data.informacaoSociodemografica.campos.relacaoParentescoCidadao"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <Item
                            label="Ocupação"
                            :value="data.informacaoSociodemografica.campos.ocupacaoCodigoCbo2002"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <Item
                            label="Qual é o curso mais elevado que frequenta ou frequentou?"
                            :value="data.informacaoSociodemografica.campos.grauInstrucaoCidadao"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <Item
                            label="Frequenta escola ou creche?"
                            :value="data.informacaoSociodemografica.campos.statusFrequentaEscola"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <Item
                            label="Situação no mercado de trabalho"
                            :value="data.informacaoSociodemografica.campos.situacaoMercadoTrabalhoCidadao"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="3">
                        <Item
                            label="Frequenta cuidador tradicional?"
                            :value="data.informacaoSociodemografica.campos.statusFrequentaBenzedeira"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <Item
                            label="Participa de grupo comunitário?"
                            :value="data.informacaoSociodemografica.campos.statusParticipaGrupoComunitario"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <Item
                            label="Crianças de 0 a 9 anos, com quem fica?"
                            :value="data.informacaoSociodemografica.campos.responsaveisPorCrianca"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="3">
                        <Item
                            label="Possui plano de saúde privado?"
                            :value="data.informacaoSociodemografica.campos.statusPossuiPlanoSaudePrivado"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <Item
                            label="É membro de povo ou comunidade tradicional?"
                            :value="data.informacaoSociodemografica.campos.statusMembroPovoComunidadeTradicional"
                        />
                    </rkm-col>

                    <rkm-col cols="5">
                        <Item
                            label="Povo ou comunidade tradicional"
                            :value="data.informacaoSociodemografica.campos.coPovoComunidadeTradicional"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="3">
                        <Item
                            label="Deseja informar orientação sexual?"
                            :value="data.informacaoSociodemografica.campos.statusDesejaInformarOrientacaoSexual"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <Item
                            label="Orientação sexual"
                            :value="data.informacaoSociodemografica.campos.orientacaoSexualCidadao"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <Item
                            label="Deseja informar identidade de gênero?"
                            :value="data.informacaoSociodemografica.campos.statusDesejaInformarIdentidadeGenero"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="Identidade de gênero"
                            :value="data.informacaoSociodemografica.campos.identidadeGeneroCidadao"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="3">
                        <Item
                            label="Tem alguma deficiência?"
                            :value="data.informacaoSociodemografica.campos.statusTemAlgumaDeficiencia"
                        />
                    </rkm-col>

                    <rkm-col cols="9">
                        <Item
                            label="Deficiências"
                            :value="data.informacaoSociodemografica.campos.deficienciasCidadao"
                        />
                    </rkm-col>
                </rkm-row>

                <Inconsistencia :inconsistencias="data.informacaoSociodemografica.inconsistencias" />

                <rkm-area title="Saída do cidadão do cadastro">
                    <rkm-row>
                        <rkm-col :cols="data.informacaoSociodemografica.campos.saidaCidadaoCadastro.campos.isMotivoSaidaObito ? 6 : 12">
                            <Item
                                label="Motivo"
                                :value="data.informacaoSociodemografica.campos.saidaCidadaoCadastro.campos.motivoSaidaCidadao"
                            />
                        </rkm-col>

                        <template v-if="data.informacaoSociodemografica.campos.saidaCidadaoCadastro.campos.isMotivoSaidaObito">
                            <rkm-col cols="2">
                                <Item
                                    label="Data de óbito"
                                    :value="data.informacaoSociodemografica.campos.saidaCidadaoCadastro.campos.dataObito"
                                />
                            </rkm-col>

                            <rkm-col cols="4">
                                <Item
                                    label="Número da declaração de óbito"
                                    :value="data.informacaoSociodemografica.campos.saidaCidadaoCadastro.campos.numeroDO"
                                />
                            </rkm-col>
                        </template>
                    </rkm-row>

                    <Inconsistencia :inconsistencias="data.informacaoSociodemografica.campos.saidaCidadaoCadastro.inconsistencias" />
                </rkm-area>
            </rkm-area>

            <rkm-area
                title="Informação Socioeconômica"
                type="fieldset"
            >
                <rkm-row>
                    <rkm-col cols="12">
                        <Item
                            label="Nos últimos três meses, os alimentos acabaram antes que você tivesse dinheiro para comprar mais comida?"
                            :value="data.informacaoSocioeconomica.campos.alimentosAcabaramAntesTerDinheiroComprarMais"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="12">
                        <Item
                            label="Nos últimos três meses, você comeu apenas alguns alimentos que ainda tinha, porque o dinheiro acabou?"
                            :value="data.informacaoSocioeconomica.campos.comeuAlgunsAlimentosQueTinhaDinheiroAcabou"
                        />
                    </rkm-col>
                </rkm-row>
                <Inconsistencia :inconsistencias="data.informacaoSocioeconomica.inconsistencias" />
            </rkm-area>

            <rkm-area
                title="Recusa do cadastro individual da atenção básica"
                type="fieldset"
            >
                <rkm-row>
                    <rkm-col cols="12">
                        <Item
                            label="Usuário recusou o cadastro por meio do termo de Recusa do Cadastro"
                            :value="data.recusaCadastro.campos.statusTermoRecusaCadastroIndividualAtencaoBasica"
                        />
                    </rkm-col>
                </rkm-row>

                <Inconsistencia :inconsistencias="data.recusaCadastro.inconsistencias" />
            </rkm-area>

            <rkm-area
                title="Condição de saúde em geral"
                type="fieldset"
            >
                <rkm-row>
                    <rkm-col cols="2">
                        <Item
                            label="Gestante"
                            :value="data.condicaoSaudeGeral.campos.statusEhGestante"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <Item
                            label="Qual é a maternidade de referência?"
                            :value="data.condicaoSaudeGeral.campos.maternidadeDeReferencia"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="Peso"
                            :value="data.condicaoSaudeGeral.campos.situacaoPeso"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="Fumante"
                            :value="data.condicaoSaudeGeral.campos.statusEhFumante"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="Usa álcool"
                            :value="data.condicaoSaudeGeral.campos.statusEhDependenteAlcool"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="2">
                        <Item
                            label="Outras drogas"
                            :value="data.condicaoSaudeGeral.campos.statusEhDependenteOutrasDrogas"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="Hipertensão"
                            :value="data.condicaoSaudeGeral.campos.statusTemHipertensaoArterial"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="Diabetes"
                            :value="data.condicaoSaudeGeral.campos.statusTemDiabetes"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="Teve AVC/Derrame"
                            :value="data.condicaoSaudeGeral.campos.statusTeveAvcDerrame"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="Teve infarto"
                            :value="data.condicaoSaudeGeral.campos.statusTeveInfarto"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="Está com hanseníase"
                            :value="data.condicaoSaudeGeral.campos.statusTemHanseniase"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="2">
                        <Item
                            label="Tem ou teve câncer"
                            :value="data.condicaoSaudeGeral.campos.statusTemTeveCancer"
                        />
                    </rkm-col>

                    <rkm-col cols="2">
                        <Item
                            label="Está com tuberculose"
                            :value="data.condicaoSaudeGeral.campos.statusTemTuberculose"
                        />
                    </rkm-col>
                    <rkm-col cols="3">
                        <Item
                            label="Teve internação nos últimos 12 meses?"
                            :value="data.condicaoSaudeGeral.campos.statusTeveInternadoEm12Meses"
                        />
                    </rkm-col>

                    <rkm-col cols="5">
                        <Item
                            label="Motivo internação nos últimos 12 meses"
                            :value="data.condicaoSaudeGeral.campos.descricaoCausaInternacaoEm12Meses"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="3">
                        <Item
                            label="Teve doença cardíaca/do coração?"
                            :value="data.condicaoSaudeGeral.campos.statusTeveDoencaCardiaca"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <Item
                            label="Quais doenças cardíacas?"
                            :value="data.condicaoSaudeGeral.campos.doencasCardiacas"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <Item
                            label="Tem ou teve problemas nos rins?"
                            :value="data.condicaoSaudeGeral.campos.statusTemTeveDoencasRins"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <Item
                            label="Quais problemas nos rins?"
                            :value="data.condicaoSaudeGeral.campos.doencasRins"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="3">
                        <Item
                            label="Tem doença respiratória/no pulmão?"
                            :value="data.condicaoSaudeGeral.campos.statusTemDoencaRespiratoria"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <Item
                            label="Quais doenças respiratórias?"
                            :value="data.condicaoSaudeGeral.campos.doencasRespiratorias"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <Item
                            label="Está acamado?"
                            :value="data.condicaoSaudeGeral.campos.statusEstaAcamado"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <Item
                            label="Está domiciliado?"
                            :value="data.condicaoSaudeGeral.campos.statusEstaDomiciliado"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="12">
                        <Item
                            label="Fez ou faz tratamento psiquiátrico ou teve internação por problema de saúde mental?"
                            :value="data.condicaoSaudeGeral.campos.statusDiagnosticoMental"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="3">
                        <Item
                            label="Usa plantas medicinais?"
                            :value="data.condicaoSaudeGeral.campos.statusUsaPlantaMedicinais"
                        />
                    </rkm-col>

                    <rkm-col cols="3">
                        <Item
                            label="Quais plantas medicinais?"
                            :value="data.condicaoSaudeGeral.campos.descricaoPlantasMedicinaisUsadas"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <Item
                            label="Usa práticas integrativas e complementares?"
                            :value="data.condicaoSaudeGeral.campos.statusUsaOutrasPraticasIntegrativasOuComplementares"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="4">
                        <Item
                            label="Outra condição de saúde 1"
                            :value="data.condicaoSaudeGeral.campos.descricaoOutraCondicao1"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <Item
                            label="Outra condição de saúde 2"
                            :value="data.condicaoSaudeGeral.campos.descricaoOutraCondicao2"
                        />
                    </rkm-col>

                    <rkm-col cols="4">
                        <Item
                            label="Outra condição de saúde 3"
                            :value="data.condicaoSaudeGeral.campos.descricaoOutraCondicao3"
                        />
                    </rkm-col>
                </rkm-row>

                <Inconsistencia :inconsistencias="data.condicaoSaudeGeral.inconsistencias" />
            </rkm-area>

            <rkm-area
                title="Cidadão em situação de rua"
                type="fieldset"
            >
                <rkm-row>
                    <rkm-col :cols="data.situacaoRua.campos.emSituacaoRua ? 3 : 12">
                        <Item
                            label="Em situação de rua?"
                            :value="data.situacaoRua.campos.statusSituacaoRua"
                        />
                    </rkm-col>

                    <template v-if="data.situacaoRua.campos.emSituacaoRua">
                        <rkm-col cols="3">
                            <Item
                                label="Tempo em situação de rua"
                                :value="data.situacaoRua.campos.tempoSituacaoRua"
                            />
                        </rkm-col>

                        <rkm-col cols="3">
                            <Item
                                label="Acompanhado por outra instituição?"
                                :value="data.situacaoRua.campos.statusAcompanhadoPorOutraInstituicao"
                            />
                        </rkm-col>

                        <rkm-col cols="3">
                            <Item
                                label="Outra instituição"
                                :value="data.situacaoRua.campos.outraInstituicaoQueAcompanha"
                            />
                        </rkm-col>
                    </template>
                </rkm-row>

                <template v-if="data.situacaoRua.campos.emSituacaoRua">
                    <rkm-row>
                        <rkm-col cols="3">
                            <Item
                                label="Recebe algum benefício?"
                                :value="data.situacaoRua.campos.statusRecebeBeneficio"
                            />
                        </rkm-col>

                        <rkm-col cols="3">
                            <Item
                                label="Possui referência familiar?"
                                :value="data.situacaoRua.campos.statusPossuiReferenciaFamiliar"
                            />
                        </rkm-col>

                        <rkm-col cols="3">
                            <Item
                                label="Visita algum familiar com frequência?"
                                :value="data.situacaoRua.campos.statusVisitaFamiliarFrequentemente"
                            />
                        </rkm-col>

                        <rkm-col cols="3">
                            <Item
                                label="Parentesco"
                                :value="data.situacaoRua.campos.grauParentescoFamiliarFrequentado"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="3">
                            <Item
                                label="Alimentação diária"
                                :value="data.situacaoRua.campos.quantidadeAlimentacoesAoDiaSituacaoRua"
                            />
                        </rkm-col>

                        <rkm-col cols="9">
                            <Item
                                label="Origem da alimentação"
                                :value="data.situacaoRua.campos.origemAlimentos"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col cols="3">
                            <Item
                                label="Acesso a higiene pessoal?"
                                :value="data.situacaoRua.campos.statusTemAcessoHigienePessoalSituacaoRua"
                            />
                        </rkm-col>

                        <rkm-col cols="9">
                            <Item
                                label="Higiene pessoal"
                                :value="data.situacaoRua.campos.higienePessoal"
                            />
                        </rkm-col>
                    </rkm-row>
                </template>

                <Inconsistencia :inconsistencias="data.situacaoRua.inconsistencias" />
            </rkm-area>
        </template>

        <template #footer>
            <rkm-button
                :disabled="!!loading"
                @click="handleExit"
            >
                Fechar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import Item from '../item/Index'
import Inconsistencia from '../inconsistencia/Index'

// Mixins.
import { repository, error } from '@/mixins'

// Vuex.
import { mapActions, mapGetters } from 'vuex'

export default {
    components: { Item, Inconsistencia },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
        inconsistenciaVersao(){

            const texto = this.inconsistencia?.inconsistencia || ''
    
            const versaoErro = this.extrairVersaoDescricao(texto)
            const versao = this.extrairVersao(texto)

            if(!versaoErro) return []

            return [
                `A versão atual do LEDI (${versao}) não é compatível com a versão do seu integrador.`        
            ]
        },
    },

    created() {

        this.repositories = {
            gerenciamentoEnvio: this.getConectaSusRepository('integracao.esus.gerenciamentoEnvio'),
        }
    },
    data: () => ({
        inconsistencia: null,
        data: null,
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(inconsistencia) {

            this.inconsistencia = inconsistencia
            this.data = null

            this.load()
            this.$refs.Modal.show()
        },
        handleExit() {

            this.$refs.Modal.hide()
        },
        load() {

            this.setLoading()

            this.repositories.gerenciamentoEnvio.getInconsistencia(this.inconsistencia.id)
                .then(({ data }) => this.data = data)
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        extrairVersaoDescricao(texto) {

            if (!texto) return null

            texto = texto.replace(/\\u00e3/g, 'ã')

            const match = texto.match(/vers[aã]o\s+([\d.]+)\s+inexistente/i)

            return match ? match[1] : null
        },
    
        extrairVersao(texto){

            if (!texto) return null

            const match = texto.match(/\d+\.\d+\.\d+/)

            return match ? match[0] : null
        }
    },
    mixins: [repository, error]
}
</script>